<template>
  <div :class="['button-item', disabled && 'disabled']" @click="onClick">
    <div class="button-item--top">
      <img src="@/assets/ticker.svg" class="ticker" v-if="ticker" />
      <a
        class="button-item--top__title"
        :href="href"
        :class="[activeLang === 'ja-JP' && 'active-lang']"
        >{{ title }}</a
      >
      <img
        :src="arrowIcon"
        alt="vector-img"
        class="button-item--top__icon"
        v-if="!isMobile"
      />
      <img
        src="@/assets/Vector-sp.svg"
        alt="vector-img"
        class="button-item--top__icon"
        v-else
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useNavigate } from '@/composable';
import { defineComponent, computed, watch, ref, inject } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'ButtonItem',
  props: {
    title: String,
    iconRsc: String,
    href: String,
    url: String,
    taget: String,
    disabled: Boolean,
    ticker: Boolean
  },
  setup(props) {
    const { navigate } = useNavigate();
    const { locale } = useI18n();
    const isMobile: any = inject('isMobile');
    const activeLang = ref(localStorage.getItem('locale'));
    const arrowIcon = computed(() => {
      return props.iconRsc || require('@/assets/img/nav/arrow.svg');
    });
    const taget = computed(() => {
      return props.taget || '_blank';
    });
    const onClick = () => {
      if (props.url) {
        navigate(props.url, taget.value === '_blank' ? 'window' : 'router');
      }
    };

    watch(
      locale,
      () => {
        activeLang.value = localStorage.getItem('locale');
      },
      { deep: true }
    );

    return {
      arrowIcon,
      onClick,
      activeLang,
      isMobile
    };
  }
});
</script>

<style scoped lang="scss">
.active-lang {
  font-family: 'Tayori Noto Sans JP' !important;
}
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
.ticker {
  padding-right: 0.6rem;
}
.button-item {
  &:hover,
  &:focus {
    cursor: pointer;
    // img {
    //   transform: translateX(0.3rem);
    // }
  }
  background: linear-gradient(90deg, #1f286f 0%, #52c3f1 100%);
  // box-shadow: 0rem 0rem 2.4rem rgba(0, 0, 0, 0.15);
  border-radius: 0rem 0rem 0.8rem 0.8rem;
  &--top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 3.9rem;
    &__title {
      font-family: 'Tayori-Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 1.8rem;
      line-height: 2.4rem;
      letter-spacing: 1.2px;
      color: #ffffff;
      padding-right: 1.8rem;
    }
  }
}
</style>
